export default "__VITE_ASSET__CEKuKnNY__"